import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Book, Heart, Phone, Mail, Film, Newspaper, Award, Sparkles } from "lucide-react";
import workshopImage from "@/assets/about-workshop.jpg";
import heritageImage from "@/assets/about-heritage.jpg";
import craftsmanshipHero from "@/assets/craftsmanship-hero.jpg";

const AboutUs = () => {
  const services = [
    {
      title: "Legătorie de artă în piele",
      items: [
        { name: "Carte de cult ortodoxă", link: "/magazin?category=carte-de-cult-ortodoxa" },
        { name: "Coperți din piele pentru cărți bibliofile", link: "/magazin?category=coperti-din-piele" },
        { name: "Albume de artă, albume de familie", link: "/magazin?category=coperti-din-piele" },
      ],
    },
    {
      title: "Cadoul inspirat, tematic",
      items: [
        { name: "Icoane", link: "/magazin?category=icoane" },
        { name: "Obiecte din piele cu tematică religioasă", link: "/magazin?category=obiecte-din-piele" },
      ],
    },
  ];

  const media = [
    {
      title: 'Emisiune la TVR 1, "Chip și asemănare"',
      description: "Despre calea duhovnicească a Iulianei Mateescu",
      link: "https://www.youtube.com/watch?v=axcjmTREr44",
      icon: Film,
    },
    {
      title: "Articol despre activitatea atelierelor Idaco",
      description: "O activitate născută din credință",
      link: "http://www.crestinortodox.ro/interviuri/dar-din-har-poveste-succes-70510.html",
      icon: Newspaper,
    },
    {
      title: "TRINITAS TV - Credință și Cultură",
      description: 'Dialog despre proiectul "Restituiri-Valori de patrimoniu"',
      link: "https://www.youtube.com/watch?v=7aKS3H5Ph4Y",
      icon: Film,
    },
    {
      title: "Secret R.O.S.T. - Film documentar",
      description: "Realizat în cadrul echipei cu Ciprian Oliviu și Iuliana Mateescu",
      link: "#",
      icon: Film,
    },
    {
      title: 'Distincția "Crucea Maria Brâncoveanu"',
      description: "Oferită Iulianei Mateescu pentru filmele realizate",
      link: "http://basilica.ro/ordinul-crucea-maria-brancoveanu-pentru-doamna-iuliana-mateescu/",
      icon: Award,
    },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      
      <main className="flex-grow pt-20">
        {/* Hero Section */}
        <section className="relative h-[70vh] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img 
              src={craftsmanshipHero} 
              alt="Atelier legătorie în piele Idaco - meșteșug tradițional" 
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-burgundy-dark/80 via-burgundy-dark/60 to-background"></div>
          </div>
          
          <div className="container mx-auto px-4 relative z-10 text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-gold/20 backdrop-blur-sm rounded-full border border-gold/40 mb-6 animate-fade-in">
              <Sparkles className="w-4 h-4 text-gold" />
              <span className="text-white font-semibold text-sm">Meșteșug autentic din 2002</span>
            </div>
            
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 animate-fade-in font-playfair" style={{ animationDelay: '0.2s' }}>
              Idaco ..dar din har..
            </h1>
            
            <p className="text-xl md:text-2xl text-cream/90 max-w-3xl mx-auto font-lora leading-relaxed animate-fade-in" style={{ animationDelay: '0.4s' }}>
              Creații născute din credinta ortodoxă, cultura tradițională și dragostea pentru ,,românesc"
            </p>
          </div>
        </section>

        {/* Story Section */}
        <section className="py-20 bg-gradient-to-b from-background to-cream/30">
          <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
              <div className="animate-fade-in">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-gold/20 backdrop-blur-sm rounded-full border border-gold/40 mb-6">
                <Book className="w-4 h-4 text-gold" />
                <span className="text-foreground font-semibold text-sm">Despre noi</span>
              </div>
                
                <h2 className="text-4xl md:text-5xl font-bold text-primary mb-6 font-playfair">
                  Atelierele Idaco ..dar din har..
                </h2>
                
                <p className="text-lg text-muted-foreground mb-6 leading-relaxed font-lora">
                  Activitatea noastră s-a zămislit din dragoste pentru ,,românesc". Creațiile atelierelor 
                  <strong> Idaco ..dar din har.. </strong>au ca izvoare de viață credința ortodoxă, cultura 
                  tradițională românească și istoria noastră. Ele reprezintă un crez materializat în obiecte, 
                  icoane, cărți și albume cu coperți din piele, fiecare în parte purtând un mesaj viu din 
                  spiritul neamului nostru.
                </p>
                
                <p className="text-lg text-muted-foreground mb-6 leading-relaxed font-lora">
                  Grija pentru execuție, detalii, creativitatea care se regăsește în seriile mici și unicat 
                  ale produselor noastre, în cei 20 ani de activitate, au făcut ca <strong>Idaco ..dar din har..</strong> să 
                  devină un brand apreciat de toți cei ce iubesc ,,frumosul" născut din credință și pasiune.
                </p>

                <div className="space-y-3 pt-4">
                  <a href="mailto:idaco_traditional@yahoo.com" className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors">
                    <Mail className="w-5 h-5 text-gold" />
                    <span className="font-lora">idaco_traditional@yahoo.com</span>
                  </a>
                  <a href="tel:+40722637470" className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors">
                    <Phone className="w-5 h-5 text-gold" />
                    <span className="font-lora">+40 722 637 470</span>
                  </a>
                </div>
              </div>

              <div className="relative animate-fade-in" style={{ animationDelay: '0.3s' }}>
                <div className="relative h-[600px] rounded-2xl overflow-hidden shadow-2xl">
                  <img 
                    src={workshopImage} 
                    alt="Meșter Idaco lucrând manual la legarea în piele a unei cărți religioase" 
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-burgundy-dark/50 to-transparent"></div>
                  <div className="absolute inset-4 border-2 border-gold/30 rounded-xl pointer-events-none"></div>
                </div>
                
                <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gradient-to-br from-gold/20 to-accent/20 rounded-full blur-3xl animate-float"></div>
                <div className="absolute -top-6 -left-6 w-32 h-32 bg-gradient-to-br from-primary/20 to-burgundy/20 rounded-full blur-3xl animate-float" style={{ animationDelay: '1s' }}></div>
              </div>
            </div>

            {/* Services Grid */}
            <div className="grid md:grid-cols-2 gap-8">
              {services.map((service, index) => (
                <div
                  key={service.title}
                  className="p-8 bg-card/80 backdrop-blur-sm rounded-2xl border-2 border-border/50 hover:border-primary/30 transition-all duration-500 hover-scale animate-fade-in"
                  style={{ animationDelay: `${index * 150}ms` }}
                >
                  <h3 className="text-2xl font-bold text-primary mb-6 font-playfair">
                    {service.title}
                  </h3>
                  <ul className="space-y-4">
                    {service.items.map((item, itemIndex) => (
                      <li key={itemIndex}>
                        <a 
                          href={item.link} 
                          className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors group"
                        >
                          <Heart className="w-5 h-5 text-gold group-hover:text-primary transition-colors" />
                          <span className="font-lora text-lg">{item.name}</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ROST Association Section */}
        <section className="py-20 bg-gradient-to-b from-cream/30 to-background">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full mb-6">
                <Sparkles className="w-4 h-4 text-primary" />
                <span className="text-primary font-semibold text-sm">Asociația</span>
              </div>
              
              <h2 className="text-4xl md:text-5xl font-bold text-primary mb-6 font-playfair">
                Asoc. Păstrarea Obiceiurilor & Tradițiilor Român...
                <br />
                R.O.S.T.
              </h2>
              
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto font-lora mb-8">
                Dedicați păstrării și promovării valorilor culturale și spirituale românești prin proiecte de restaurare și documentare.
              </p>

              <div className="space-y-3 max-w-md mx-auto">
                <a href="mailto:idaco_traditional@yahoo.com" className="flex items-center justify-center gap-3 text-muted-foreground hover:text-primary transition-colors">
                  <Mail className="w-5 h-5 text-gold" />
                  <span className="font-lora">idaco_traditional@yahoo.com</span>
                </a>
                <a href="tel:+40722637470" className="flex items-center justify-center gap-3 text-muted-foreground hover:text-primary transition-colors">
                  <Phone className="w-5 h-5 text-gold" />
                  <span className="font-lora">+40 722 637 470</span>
                </a>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
              {media.map((item, index) => {
                const Icon = item.icon;
                return (
                  <a
                    key={index}
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group p-6 bg-card/80 backdrop-blur-sm rounded-2xl border-2 border-border/50 hover:border-primary/30 transition-all duration-500 hover-scale hover-glow animate-fade-in"
                    style={{ animationDelay: `${index * 150}ms` }}
                  >
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                        <Icon className="w-6 h-6 text-primary" />
                      </div>
                      <div>
                        <h3 className="text-lg font-bold text-foreground mb-2 group-hover:text-primary transition-colors font-playfair">
                          {item.title}
                        </h3>
                        <p className="text-muted-foreground font-lora leading-relaxed text-sm">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </a>
                );
              })}
            </div>
          </div>
        </section>

        {/* Heritage Section */}
        <section className="py-20 bg-gradient-to-b from-background to-cream/30 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-96 h-96 bg-gold/10 rounded-full blur-3xl animate-float"></div>
          
          <div className="container mx-auto px-4 relative">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div className="relative animate-fade-in order-2 md:order-1">
                <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-2xl">
                  <img 
                    src={heritageImage} 
                    alt="Cărți legate în piele de Idaco - patrimoniu cultural românesc" 
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-burgundy-dark/40 to-transparent"></div>
                  <div className="absolute inset-4 border-2 border-gold/30 rounded-xl pointer-events-none"></div>
                </div>
              </div>

              <div className="animate-fade-in order-1 md:order-2" style={{ animationDelay: '0.3s' }}>
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full mb-6">
                  <Heart className="w-4 h-4 text-primary" />
                  <span className="text-primary font-semibold text-sm">Misiunea noastră</span>
                </div>
                
                <h2 className="text-4xl md:text-5xl font-bold text-primary mb-6 font-playfair">
                  Un mesaj viu din spiritul neamului
                </h2>
                
                <p className="text-lg text-muted-foreground mb-6 leading-relaxed font-lora">
                  Fiecare creație a atelierelor noastre poartă un mesaj viu din spiritul neamului românesc, 
                  îmbinând credința ortodoxă cu măiestria artizanală transmisă din generație în generație.
                </p>
                
                <p className="text-lg text-muted-foreground mb-6 leading-relaxed font-lora">
                  Lucrările noastre sunt mai mult decât simple obiecte – sunt mărturii ale unei tradiții 
                  vii, păstrate cu grijă și dedicație în fiecare detaliu executat cu măiestrie.
                </p>

                <div className="bg-gradient-to-br from-primary/10 to-accent/10 rounded-2xl p-6 border-2 border-primary/20">
                  <p className="text-xl font-semibold text-primary mb-2 font-playfair">
                    "Grija pentru execuție, detalii, creativitatea care se regăsește în seriile mici 
                    și unicat ale produselor noastre."
                  </p>
                  <p className="text-muted-foreground font-lora">
                    — Idaco ..dar din har..
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-primary/10 via-accent/5 to-background relative overflow-hidden">
          <div className="absolute inset-0 opacity-5">
            <div className="absolute top-20 left-10 w-72 h-72 bg-primary rounded-full blur-3xl"></div>
            <div className="absolute bottom-20 right-10 w-72 h-72 bg-accent rounded-full blur-3xl"></div>
          </div>
          
          <div className="container mx-auto px-4 relative text-center">
            <h2 className="text-4xl md:text-5xl font-bold text-primary mb-6 font-playfair animate-fade-in">
              Haideți să creăm împreună
            </h2>
            
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto mb-8 font-lora animate-fade-in" style={{ animationDelay: '0.2s' }}>
              Fie că doriți să restaurați o carte prețioasă sau să comandați o nouă lucrare personalizată, 
              suntem aici să vă ajutăm să transformați visul în realitate.
            </p>

            <a 
              href="/#contact" 
              className="inline-flex items-center gap-2 px-8 py-4 bg-primary hover:bg-primary/90 text-white rounded-full font-semibold transition-all duration-300 hover-scale hover-glow shadow-lg animate-fade-in"
              style={{ animationDelay: '0.4s' }}
            >
              <Heart className="w-5 h-5" />
              Contactează-ne
            </a>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default AboutUs;
